import { render } from "./CustomerOrders.vue?vue&type=template&id=6affb687"
import script from "./CustomerOrders.vue?vue&type=script&lang=ts"
export * from "./CustomerOrders.vue?vue&type=script&lang=ts"
script.render = render

export default script